import { useEffect } from 'react'
import { useTranslation } from '../hooks/useTranslation'

const servicesHero = '/images/services-hero.png'
const serviceCrossBorder = '/images/service-cross-border.png'
const serviceDueDiligence = '/images/service-due-diligence.png'
const serviceCompliance = '/images/service-compliance.png'
const serviceFinance = '/images/service-finance.png'

export default function Services() {
  const { t, getPageTitle, lang } = useTranslation()

  useEffect(() => {
    document.title = getPageTitle('services')
  }, [lang, getPageTitle])

  const serviceCategories = [
    {
      image: serviceCrossBorder,
      title: t('services.categories.crossBorder'),
      services: [
        t('services.list.crossBorderDebtCollection'),
        t('services.list.overseasReceivables'),
        t('services.list.buyerCreditVerification'),
        t('services.list.tradeRiskWarning'),
        t('services.list.debtNegotiation'),
        t('services.list.overseasBadDebt'),
        t('services.list.commercialDisputeMediation'),
      ]
    },
    {
      image: serviceDueDiligence,
      title: t('services.categories.dueDiligence'),
      services: [
        t('services.list.overseasCreditInvestigation'),
        t('services.list.globalAssetVerification'),
        t('services.list.investmentRiskDueDiligence'),
        t('services.list.tradeContractReview'),
        t('services.list.exportCreditInsurance'),
        t('services.list.antiFraudSolutions'),
      ]
    },
    {
      image: serviceCompliance,
      title: t('services.categories.compliance'),
      services: [
        t('services.list.odiFiling'),
        t('services.list.overseasEntityRegistration'),
        t('services.list.capitalCompliance'),
        t('services.list.overseasMarketEntry'),
        t('services.list.evidenceNotarization'),
      ]
    },
    {
      image: serviceFinance,
      title: t('services.categories.finance'),
      services: [
        t('services.list.supplyChainFinance'),
        t('services.list.receivablesFactoring'),
        t('services.list.assetRecovery'),
        t('services.list.foreignExchangeSolutions'),
      ]
    },
  ]

  return (
    <>
      {/* Hero Section */}
      <section className="hero hero-with-bg">
        <div className="hero-bg-image">
          <img src={servicesHero} alt="Business strategy meeting" />
          <div className="hero-overlay"></div>
        </div>
        <div className="container hero-content">
          <h1>{t('services.title')}</h1>
          <p>{t('services.subtitle')}</p>
        </div>
      </section>

      {/* Services by Category */}
      <section className="services section">
        <div className="container">
          <div className="services-grid-categories">
            {serviceCategories.map((category, index) => (
              <div key={index} className="service-category-card">
                <div className="service-category-header">
                  <img
                    src={category.image}
                    alt={category.title}
                    className="service-category-image"
                  />
                  <h3>{category.title}</h3>
                </div>
                <ul className="service-list">
                  {category.services.map((service, i) => (
                    <li key={i} className="service-list-item">
                      <span className="service-check">✓</span>
                      <span>{service}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section" style={{ background: 'var(--primary)', color: 'white', textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ color: 'white', marginBottom: '16px' }}>
            {t('services.cta.title')}
          </h2>
          <p style={{ color: 'var(--text-light)', marginBottom: '32px', maxWidth: '600px', margin: '0 auto 32px' }}>
            {t('services.cta.subtitle')}
          </p>
          <a href="/contact" className="btn btn-gold">
            {t('services.cta.button')}
          </a>
        </div>
      </section>
    </>
  )
}
